module.exports = __webpack_public_path__ + "img/leave-history.2c5e2fb8.png";